import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_PRIDE_LOGO = defineFcm('enable_pride_logo').asBoolean().withDefault(false).toConfig();
